<!--
NOTE: visually looks like AppAssignUser
     (lightweight version of AppAssignUser without dropdown; good for virtual lists - scroll without glitches)
TODO: sizes: [sm, md, lg]
-->

<template>
    <div v-if="user && user.uuid" v-tooltip="withRightCaption ? null : fullName">
        <div class="position-relative d-inline-block">
            <avatar :size="31"
                    :inline="true"
                    :customStyle="{ 'vertical-align': 'middle' }"
                    :src="membersAvatars[user.uuid]"
                    :username="fullName"/>
            <div v-if="user.uuid !== userUUID && membersPresence[user.uuid]"
                 v-tooltip="'Online'"
                 class="is-online-user">
            </div>
        </div>
        <div v-if="withRightCaption" class="d-inline-block ml-2 text-dark">
            {{ fullName }}
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {getUserFullName} from '@/utils/user'

export default {
    name: 'AppUserAvatar',
    props: {
        user: {
            required: true
        },
        withRightCaption: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters([
            'userUUID',
            'membersAvatars',
            'membersPresence'
        ]),

        fullName() {
            return getUserFullName(this.user)
        }
    }
}
</script>

<style lang="scss" scoped>
.is-online-user {
    position: absolute;
    background-color: $color-success;
    top: 0;
    right: 0;
    width: 7px;
    height: 7px;
    border-radius: 50%;
}
</style>
